export default "__VITE_ASSET__CF1Y3QMs__"